import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";
// const BASE_URL = "http://localhost:5500";
// const BASE_URL = "http://52.87.3.228:5500";OtherChages

function OtherCharges() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [OtherChages, setOtherChages] = useState([]);

  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [key, setKey] = useState(0);

  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/Parentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const highestValueCharges =

  const getOtherCharges = async () => {
    try {
      const response = await privateRequest.get(
        "OtherCharges/getOchargesStatus"
      );

      setOtherChages(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteOtherCharges = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `/OtherCharges/deleteOcharges/${_id}`
        );
        getOtherCharges();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  console.log("selectedGroup", selectedGroup);
  const AddOthercharges = async (event) => {
    event.preventDefault();
    if (!selectedGroup) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "please select parent category ",
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("ChargesIcon", selectedFile);
      // selectedGroup?.forEach((group) => {
      formData.append("Pcat", selectedGroup?.value);
      // });
      formData.append("ChargesName", name);
      formData.append("ChargesValue", value);
      formData.append("Status", selectedStatus);

      let response;
      if (selectedItem?._id) {
        response = await privateRequest.put(
          `OtherCharges/UpdateCharges/${selectedItem._id}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "OtherCharges updated successfully!",
        });
      } else {
        // Add new item
        response = await privateRequest.post(
          "OtherCharges/AddCharges",
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Other Charges added successfully!",
        });
      }

      console.log("POST Response:", response);
      getOtherCharges();
      setShowModal(false);

      setSelectedFile(null);
      setSelectedStatus("");
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    getOtherCharges();
    getParentCategory();
  }, []);

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedGroup({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
  };

  let parentCategoryValues = {
    value: selectedItem?.Pcat && selectedItem?.Pcat[0]?._id,
    label: selectedItem?.Pcat && selectedItem?.Pcat[0]?.PCName,
  };

  useEffect(() => {
    if (selectedItem) {
      setSelectedGroup(parentCategoryValues);
      setName(selectedItem?.ChargesName);
      setValue(selectedItem?.ChargesValue);

      setImagePreview(Image_URL + selectedItem?.ChargesIcon);
    }
  }, [selectedItem]);

  console.log("setImagePreview", imagePreview);
  console.log("selectedFile", selectedFile);

  return (
    <>
      {OtherChages.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">OtherCharges</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);
                        setImagePreview(null);
                        setSelectedItem(null);
                        setValue("");
                        setName("");

                        setSelectedGroup("");

                        setSelectedStatus("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm no-footer text-center"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">ParentId</th>
                            <th scope="col">Name</th>
                            <th scope="col">Value</th>
                            <th scope="col">ChargesIcon</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {OtherChages.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.Pcat[0]?.PCName}
                              </td>
                              <td className="align-center">
                                {item?.ChargesName}
                              </td>
                              <td className="align-center">
                                {item?.ChargesValue}
                              </td>

                              <td className="align-center">
                                {item?.ChargesIcon && (
                                  <img
                                    src={`${Image_URL}${item?.ChargesIcon}`}
                                    alt="Icone Image"
                                    height="100"
                                    width="100"
                                  />
                                )}
                              </td>

                              <td>
                                {" "}
                                <span
                                  className={`badge ${
                                    item.Status
                                      ? "badge-primary"
                                      : "badge-danger"
                                  }`}
                                >
                                  {item.Status ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={(event) => {
                                      setSelectedItem(item);

                                      setSelectedFile(null);
                                      setSelectedStatus(
                                        item.Status ? "1" : "0"
                                      );

                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>

                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteOtherCharges(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                OtherCharges
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setShowModal(false);

                  setImagePreview(null);
                  setSelectedItem(null);
                  setValue("");
                  setName("");

                  setSelectedGroup("");
                }}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddOthercharges}>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Parent Category</label>

                      <Select
                        isClearable
                        label={selectedGroup?.label}
                        value={selectedGroup}
                        onChange={handleParentCategoryChange}
                        options={
                          parentCategory.map((category) => ({
                            value: category._id,
                            label: category.PCName,
                          })) || []
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        id="inputgroupName"
                        className="form-control"
                        placeholder="Charges Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Value</label>
                      <input
                        type="text"
                        id="inputgroupName"
                        className="form-control"
                        placeholder="Value"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-8">
                    <div className="form-group">
                      <label className="mb-0">Image</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>

                  {imagePreview && (
                    <div className="col-lg-12">
                      <img
                        width="80"
                        height="50"
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  )}
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItem?._id ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default OtherCharges;
